/** Shared API / reporting host resolution (used by axios and DevExpress reporting). */

/**
 * Prefer same-origin `/api` so one SPA build works for every tenant host
 * (nginx / CRA setupProxy forwards to GenWebApi and preserves Host for tenancy).
 *
 * Set REACT_APP_API_BASE_URL only when the API is on a different origin.
 */
export function getApiBaseUrl() {
  const configuredBase =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL;
  if (configuredBase) {
    return configuredBase.replace(/\/+$/, '');
  }

  return '/api';
}

/** API origin for DevExpress reporting (must match login cookie host). */
export function getReportingHost() {
  const override = process.env.REACT_APP_REPORTING_HOST;
  if (override) {
    const trimmed = override.replace(/\/+$/, '');
    return `${trimmed}/`;
  }

  const apiBase = getApiBaseUrl();
  if (apiBase.startsWith('/')) {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/`;
    }
    return '/';
  }

  const root = apiBase.replace(/\/api\/?$/i, '');
  return root.endsWith('/') ? root : `${root}/`;
}

export const API_BASE = getApiBaseUrl();
export const REPORTING_HOST = getReportingHost();
